var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarNoBorderActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4045 20V18.341C9.43856 18.1935 7.98299 17.4747 7 16.424L8.22873 14.765C8.94707 15.5207 10.0246 16.2028 11.4045 16.4055V12.8479C9.45747 12.3687 7.39698 11.6866 7.39698 9.27189C7.39698 7.3917 8.96597 5.91705 11.4045 5.71429V4H12.9168V5.73272C14.448 5.89862 15.7335 6.47005 16.7164 7.3917L15.4499 8.99539C14.7316 8.31336 13.8431 7.8894 12.9168 7.70507V10.8756C14.8828 11.3917 17 12.1106 17 14.5806C17 16.4608 15.7524 18.1014 12.9168 18.341V20H11.4045ZM14.7505 14.7834C14.7505 13.9539 13.9565 13.5484 12.9168 13.235V16.424C14.2212 16.2212 14.7505 15.4839 14.7505 14.7834ZM9.66541 9.12442C9.66541 9.84332 10.4026 10.212 11.4045 10.4885V7.6129C10.327 7.7235 9.66541 8.31336 9.66541 9.12442Z",
    fill: "#933cc1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarNoBorderActive);
export default __webpack_public_path__ + "static/media/dollar-no-border-active.53d3f3a4606fbdda4fc8db2086ecb326.svg";
export { ForwardRef as ReactComponent };